import gql from 'graphql-tag'

export const QUERY_GET_CAMPAIGNS_RESULTS = gql`
  query GenericCampaignsResults(
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $measuringDate: [String]
    $channels: [ChannelEnum]
    $products: [String]
    $noProducts: Boolean
    $status: [StatusEnum]
    $frequencyType: CampaignFrequencyTypeEnum
    $campaignIds: [ID]
    $campaignTypes: [CampaignTypeEnum]
  ) {
    genericCampaigns(
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      measuringDate: $measuringDate
      channels: $channels
      products: $products
      noProducts: $noProducts
      status: $status
      frequencyType: $frequencyType
      campaignIds: $campaignIds
      campaignTypes: $campaignTypes
    ) {
      records
      page
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        mode
        message {
          send_date
          send_time
          text
        }
        channels {
          email {
            active
          }
          whatsapp {
            active
          }
          push {
            active
          }
          sms {
            active
          }
        }
        campaign_type
        mode
        segments {
          _id
        }
        products {
          name
          sku
          erp_categories {
            id_erp
            name
          }
        }
        units {
          id_erp
          name
        }
        messages_dispatcher {
          budget {
            channels {
              whatsapp
              sms
              push
              email
            }
          }
        }
        metrics {
          clients_metrics {
            received {
              count
            }
            received_and_bought {
              count
              revenue
              average_ticket
            }
            received_with_products {
              count
              revenue
            }
            received_with_only_products {
              count
            }
          }
          general_metrics {
            general {
              sent {
                messages
              }
              received {
                messages
              }
              clicked {
                messages
              }
              segments_quantity {
                messages
              }
              senders_quantity {
                messages
              }
              read {
                messages
              }
            }
          }
          analytic_metrics {
            credits
            price
            received_roi
          }
          contacts_metrics {
            blacklisted_quantity
          }
          products_metrics {
            products_count
            table {
              product {
                sku
                name
              }
              received {
                quantity
                revenue
              }
            }
            totals {
              received {
                quantity
                revenue
                tickets
                clients
              }
              total {
                quantity
              }
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_AGGREGATED_CAMPAIGNS_RESULTS_METRICS = gql`
  query AggregatedCampaignMetrics(
    $measuringDate: [String!]!
    $products: [String]
    $noProducts: Boolean
    $status: [StatusEnum]
    $mode: [CampaignModeEnum]
    $campaignTypes: [CampaignTypeEnum]
    $campaignIds: [String]
  ) {
    aggregatedCampaignMetrics(
      mode: $mode
      measuringDate: $measuringDate
      products: $products
      noProducts: $noProducts
      status: $status
      campaignTypes: $campaignTypes
      campaignIds: $campaignIds
    ) {
      clients_received_bought
      campaign_revenue
      average_ticket_clients_received
      total_roi
      total_price
    }
  }
`

export const QUERY_GET_CAMPAIGNS_IDS = gql`
  query GenericCampaignsIds(
    $measuringDate: [String]
    $channels: [ChannelEnum]
    $products: [String]
    $noProducts: Boolean
    $status: [StatusEnum]
    $frequencyType: CampaignFrequencyTypeEnum
    $necessaryFields: [String!]
    $campaignTypes: [CampaignTypeEnum]
  ) {
    genericCampaigns(
      measuringDate: $measuringDate
      channels: $channels
      products: $products
      noProducts: $noProducts
      status: $status
      frequencyType: $frequencyType
      necessaryFields: $necessaryFields
      campaignTypes: $campaignTypes
    ) {
      campaigns {
        _id
        title
        initial_date
        final_date
        mode
      }
    }
  }
`

export const QUERY_METRICS_KPI = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate) {
      average_ticket {
        value
      }
      revenue {
        value
      }
    }
  }
`
export const QUERY_METRICS_KPI_REVENUE_HISTORY = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!, $campaignIds: [ID], $groupBy: MetricGroupBy, $productIds: [String]) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate, campaignIds: $campaignIds, groupBy: $groupBy, productIds: $productIds) {
      revenue {
        value
        date
      }
      total_active_campaigns {
        value
        date
      }
    }
  }
`
export const QUERY_CLIENTS_NOT_RECEIVED_CAMPAIGNS_BY_CHANNEL = gql`
  query ClientsNotReceivedCampaignsByChannel($initialDate: String!, $finalDate: String!, $channels: [CampaignModeEnum], $campaignIds: [ID]) {
    clientsNotReceivedCampaignsByChannel(initialDate: $initialDate, finalDate: $finalDate, channels: $channels, campaignIds: $campaignIds) {
      channel
      clients_count
      clients_received_count
      clients_not_received_count
      percent
    }
  }
`

export const QUERY_TOTAL_CLIENTS_NOT_RECEIVED_CAMPAIGNS = gql`
  query TotalClientsNotReceivedCampaigns($initialDate: String!, $finalDate: String!, $campaignIds: [ID]) {
    totalClientsNotReceivedCampaigns(initialDate: $initialDate, finalDate: $finalDate, campaignIds: $campaignIds) {
      not_received
      not_received_and_lost
      come_back_to_buy
    }
  }
`

export const QUERY_GENERAL_RESULTS_CHANNELS = gql`
  query CampaignsChannelsMetrics($initialDate: String!, $finalDate: String!, $campaignIds: [ID!]!, $productIds: [ID], $channels: [CampaignModeEnum!]!) {
    campaignsChannelsMetrics(initialDate: $initialDate, finalDate: $finalDate, campaignIds: $campaignIds, productIds: $productIds, channels: $channels) {
      client_metrics {
        channels {
          email {
            received_and_bought {
              revenue
            }
          }
          push {
            received_and_bought {
              revenue
            }
          }
          sms {
            received_and_bought {
              revenue
            }
          }
          whatsapp {
            received_and_bought {
              revenue
            }
          }
        }
      }
      general_metrics {
        channels {
          email {
            sent {
              messages
            }
            received {
              messages
            }
          }
          push {
            sent {
              messages
            }
            received {
              messages
            }
          }
          sms {
            sent {
              messages
            }
            received {
              messages
            }
          }
          whatsapp {
            sent {
              messages
            }
            received {
              messages
            }
          }
        }
      }
      analytic_metrics {
        channels {
          email {
            price
          }
          push {
            price
          }
          sms {
            price
          }
          whatsapp {
            price
          }
        }
      }
    }
  }
`
export const QUERY_GENERAL_RESULTS_FUNNEL = gql`
  query CampaignsChannelsMetrics($initialDate: String!, $finalDate: String!, $campaignIds: [ID!]!, $productIds: [ID], $channels: [CampaignModeEnum!]!) {
    campaignsChannelsMetrics(initialDate: $initialDate, finalDate: $finalDate, campaignIds: $campaignIds, productIds: $productIds, channels: $channels) {
      client_metrics {
        general {
          received {
            count
            revenue
          }
          received_and_bought {
            count
            revenue
          }
          received_with_products {
            count
            revenue
          }
          received_with_only_products {
            count
            revenue
          }
        }
        channels {
          sms {
            received {
              count
            }
            received_and_bought {
              count
            }
            received_with_products {
              count
            }
            received_with_only_products {
              count
            }
          }
          email {
            received {
              count
            }
            received_and_bought {
              count
            }
            received_with_products {
              count
            }
            received_with_only_products {
              count
            }
          }
          whatsapp {
            received {
              count
            }
            received_and_bought {
              count
            }
            received_with_products {
              count
            }
            received_with_only_products {
              count
            }
          }
          push {
            received {
              count
            }
            received_and_bought {
              count
            }
            received_with_products {
              count
            }
            received_with_only_products {
              count
            }
          }
        }
      }
    }
  }
`
